'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Brush', []).factory('BrushSelectionFilterFactory', require('./factories/BrushSelectionFilterFactory'));